import { useCallback } from 'react';
import { useDeleteMediaMutation, useMediaUploadMutation } from 'features/media';
import type { ExtendedDescriptionImageFormContentValues } from '../components';

const EVENT_COVER_PHOTO_TYPE = 'content_event_cover_photo';

type UploadEventCoverPhotoParams = {
  eventId: string;
  existingCoverPhotoId?: string;
  heroImage: ExtendedDescriptionImageFormContentValues['heroImage'];
};

export const useUploadEventCoverPhoto = () => {
  const { isPending, mutateAsync: uploadMediaMutation } = useMediaUploadMutation();
  const { isPending: isDeletingCoverPhoto, mutateAsync: deleteMediaMutation } = useDeleteMediaMutation();

  const uploadEventCoverPhoto = useCallback(
    async ({ eventId, existingCoverPhotoId, heroImage }: UploadEventCoverPhotoParams) => {
      const heroImageFile = heroImage?.[0]?.originFileObj;

      // Image from initial values is not uploaded to BE.
      if (!heroImageFile) {
        return;
      }

      if (existingCoverPhotoId) {
        await deleteMediaMutation({ id: existingCoverPhotoId });
      }

      await uploadMediaMutation({
        file: heroImageFile,
        ref: eventId,
        type: EVENT_COVER_PHOTO_TYPE,
      });
    },
    [deleteMediaMutation, uploadMediaMutation],
  );

  return {
    isUploadingCoverPhoto: isPending || isDeletingCoverPhoto,
    uploadEventCoverPhoto,
  };
};
